/*
 * Add-to-Cart des LP-Offer-Stacks (sections/lucid-offer-stack.liquid).
 *
 * Das Skript ist bewusst eine Verbesserung und keine Voraussetzung: Das
 * Formular ist ein gewoehnlicher POST auf /cart/add, die Abo-Auswahl sind
 * echte Radios mit name="selling_plan". Ohne JavaScript kauft man also
 * trotzdem — nur ohne Drawer und ohne Cart-Attribut.
 *
 * Was es zusaetzlich tut:
 *
 * 1) Cart-Attribut `lp_angle`. /cart/add kennt keine Cart-Attribute, nur
 *    Line-Item-Properties. Das Attribut muss deshalb in einem zweiten
 *    Request per /cart/update.js gesetzt werden. Es landet als Zusatzangabe
 *    an der Bestellung — die Bruecke, um "welches Angle bringt Umsatz" zu
 *    beantworten statt nur "welches Angle bringt Klicks".
 *    Die Line-Item-Property `_lp_angle` im Formular ist der Gurt dazu: sie
 *    geht auch ohne dieses Skript mit.
 *
 * 2) Warenkorb aktualisieren. Das Theme haengt an einem einzigen Event
 *    (`cart:update`, siehe assets/events.js): Cart-Icon, Drawer und
 *    Cart-Items-Sections hoeren darauf. Wir feuern dasselbe Event als
 *    CustomEvent — als reines Script (kein Modul) koennen wir die
 *    Event-Klassen nicht importieren, die Form des `detail`-Objekts ist
 *    aber alles, worauf die Listener zugreifen.
 *
 * 3) Preiszeile umschalten. Nur Kosmetik: Jede Kaufoption traegt ihren Preis
 *    ohnehin selbst, damit ohne Skript nichts Falsches dasteht.
 *
 * Faellt einer der beiden Requests aus, wird das Formular ganz normal
 * abgeschickt. Ein kaputter Warenkorb-Request darf auf einer bezahlten
 * Landing Page nicht in einer Sackgasse enden.
 */
(function () {
  'use strict';

  // Die Section bindet dieses Skript selbst ein. Stehen zwei Offer-Stacks auf
  // einer Seite, laedt der Browser es zweimal - und ohne diese Sperre haetten
  // wir zwei Submit-Listener am document, also zwei /cart/add pro Klick.
  if (window.lucidOfferStackReady) return;
  window.lucidOfferStackReady = true;

  var SELECTOR_FORM = '[data-lucid-offer-form]';

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addUrl() {
    var themeRoutes = window.Theme && window.Theme.routes;
    // Theme.routes.cart_add_url endet bereits auf .js (snippets/scripts.liquid).
    if (themeRoutes && themeRoutes.cart_add_url) return themeRoutes.cart_add_url;
    return routeRoot() + 'cart/add.js';
  }

  function updateUrl() {
    var themeRoutes = window.Theme && window.Theme.routes;
    if (themeRoutes && themeRoutes.cart_update_url) return themeRoutes.cart_update_url + '.js';
    return routeRoot() + 'cart/update.js';
  }

  /** Section-IDs der Warenkorb-Sections, damit /cart/update.js sie gleich mitrendert. */
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (node) {
      var id = node.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function showError(form, message) {
    var box = form.querySelector('[data-lucid-offer-error]');
    if (!box) return;
    box.textContent = message;
    box.classList.remove('hidden');
  }

  function clearError(form) {
    var box = form.querySelector('[data-lucid-offer-error]');
    if (!box) return;
    box.textContent = '';
    box.classList.add('hidden');
  }

  /**
   * Preiszeile an die gewaehlte Kaufoption angleichen.
   *
   * Mitgezogen werden Preis, Streichpreis, Grundpreis („0,67 € pro
   * Focus-Boost"), Ersparnis-Plakette und Rabatt-Badge. Alle fuenf Werte
   * stehen fertig gerechnet als data-Attribute am jeweiligen Radio - dieses
   * Skript rechnet nichts, es setzt nur um. Sonst muesste die Rundung an
   * zwei Stellen gepflegt werden, und die beiden wuerden auseinanderlaufen.
   *
   * Ein leeres Attribut heisst „nicht anzeigen": Ohne Streichpreis gibt es
   * weder Plakette noch Badge.
   */
  function syncPrice(form) {
    var checked = form.querySelector('input[name="selling_plan"]:checked');
    if (!checked) return;

    var card = form.closest('.lucid-offer__card');
    if (!card) return;

    var priceEl = card.querySelector('[data-lucid-offer-price]');
    if (priceEl && checked.dataset.price) priceEl.textContent = checked.dataset.price;

    setOrHide(card.querySelector('[data-lucid-offer-compare]'), checked.dataset.compare);
    setOrHide(card.querySelector('[data-lucid-offer-unit]'), checked.dataset.unit);
    setOrHide(card.querySelector('[data-lucid-offer-savings]'), checked.dataset.savings);
    setOrHide(card.querySelector('[data-lucid-offer-badge]'), checked.dataset.badge);
  }

  /** Text setzen, oder das Element ausblenden, wenn es keinen gibt. */
  function setOrHide(el, value) {
    if (!el) return;
    if (value) {
      el.textContent = value;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function submitForm(form, event) {
    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    if (button && button.disabled) return;

    clearError(form);
    if (button) button.disabled = true;

    var data = new FormData(form);

    // Leerer selling_plan bedeutet Einmalkauf. Das Feld dann gar nicht erst
    // mitschicken, statt sich auf die Auslegung eines leeren Wertes zu verlassen.
    if (!data.get('selling_plan')) data.delete('selling_plan');

    var angle = form.dataset.lpAngle || '';

    fetch(addUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
    })
      .then(function (response) {
        return response.json().then(function (json) {
          // /cart/add.js antwortet bei Fehlern mit 4xx und einer description.
          if (!response.ok) throw new Error(json.description || json.message || 'cart_add_failed');
          return json;
        });
      })
      .then(function () {
        var update = new FormData();
        if (angle) update.append('attributes[lp_angle]', angle);

        var sections = cartSectionIds();
        if (sections.length) update.append('sections', sections.join(','));

        return fetch(updateUrl(), {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: update,
        }).then(function (response) {
          return response.json();
        });
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: form.closest('.section') ? form.closest('.section').id : 'lucid-offer-stack',
              data: {
                source: 'lucid-offer-stack',
                itemCount: cart && cart.item_count,
                sections: cart && cart.sections,
              },
            },
          })
        );

        if (button) button.disabled = false;
      })
      .catch(function (error) {
        if (button) button.disabled = false;

        // Bekannter Fehler vom Warenkorb (z. B. ausverkauft): anzeigen.
        // Alles andere (Netzwerk, unerwartete Antwort): das Formular normal
        // abschicken, damit der Kauf nicht an unserem Skript scheitert.
        if (error && error.message && error.message !== 'cart_add_failed') {
          showError(form, error.message);
          return;
        }

        form.submit();
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target instanceof Element ? event.target.closest(SELECTOR_FORM) : null;
    if (form) submitForm(form, event);
  });

  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element)) return;
    if (event.target.getAttribute('name') !== 'selling_plan') return;

    var form = event.target.closest(SELECTOR_FORM);
    if (form) syncPrice(form);
  });

  // Zurueck-Taste (Back-Forward-Cache, vor allem iOS Safari): Wird die Seite
  // verlassen, waehrend der Kaufen-Button gesperrt ist - etwa beim
  // Rueckfall auf form.submit() oder einem Wechsel mitten in der Anfrage -,
  // kommt sie beim Zurueckgehen eingefroren wieder, Button gesperrt. Dann
  // freigeben. Nur die Submit-Buttons: der ausverkaufte Button ist
  // type="button" und bleibt gesperrt (sections/lucid-offer-stack.liquid).
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll(SELECTOR_FORM + ' button[type="submit"]').forEach(function (button) {
      button.disabled = false;
    });
  });

  // Beim Laden einmal angleichen: Ist das Abo vorausgewaehlt, muss die
  // Preiszeile das sofort zeigen und nicht erst nach dem ersten Klick.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(SELECTOR_FORM).forEach(syncPrice);
  });
})();
